import React, { useState, useEffect } from 'react';
import classNames from "classnames";
/* Styles */
import './modalform.css';
/* Assets */
import iconClose from '../../../assets/icons/close.svg';

const ModalForm = ({ isOpen, onClose, children, customClassName }) => {
  const [shouldRender, setShouldRender] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
    }
  }, [isOpen]);

  const handleClose = () => {
    setShouldRender(false);
    onClose();
  };

  if (!shouldRender) return null;

  return (
    <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
      <div className={classNames("modal-content", customClassName)}>
        {onClose && 
          (
          <button className="close-button" onClick={handleClose}>
            <img src={iconClose} alt='' />
          </button>
          )
        }
        {children}
      </div>
    </div>
  );
}

export default ModalForm;
